import { layout } from 'src/styles/layout';
import styled from 'styled-components';

const confettiShapeOrangeTriangle = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyMSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNi42NDUxIDIyLjYxNzdMMi4xOTkzNSAyLjAwMzk2TDE5LjY5MTcgNS4wMzQ2MUwxNi42NDUxIDIyLjYxNzdaIiBzdHJva2U9IiNGRjcwNjIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K';
const confettiShapeYellowHexagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMi42Nzc3IDM1LjM1NDlMMjUuMTgzMSAyMi43MzYzTDI1LjE4MzEgMTIuNTA1TDEyLjY3NzcgNS4zNDA1OGUtMDVMMC4xNzI0NCAxMi41MDVMMC4xNzI0MTkgMjIuNzM2MkwxMi42Nzc3IDM1LjM1NDlaIiBmaWxsPSIjRkZERjZFIi8+Cjwvc3ZnPgo=';
const confettiShapeBlueRhombus = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDUuNDk2ODNMMTEuNjAyNyAtMC4wMDAxMjEzODdMMjMuMzI5NSAyNC43NTIyTDUuOTk4OTEgMTguMTU5TDAgNS40OTY4M1oiIGZpbGw9IiMxQ0FCQkYiLz4KPC9zdmc+Cg==';

export const InterviewProcessConfettiWrapper = styled.div`
  max-width: 100vw !important;

  @media screen and (min-width: ${layout.subLg}) {
    background:
      url(${confettiShapeOrangeTriangle}) 12% 40% / 19px auto no-repeat,
      url(${confettiShapeYellowHexagon}) 84% 15% / 18px auto no-repeat,
      url(${confettiShapeBlueRhombus}) 88% 65% / 22px auto no-repeat;
  }
`

export const InterviewProcessContainer = styled.div`
  display: grid;
  max-width: 940px;
  row-gap: 6rem;
  margin: 4rem auto 8rem !important;
  padding-left: 24px;
  padding-right: 24px;
`

export const InterviewProcessTitle = styled.div`
  display: grid;
  row-gap: 4rem;

  & > a {
    margin-top: 3rem;
    padding: .85em 5.5em;
  }
`

export const InterviewProcessIconography = styled.div`
  display: grid;
  column-gap: 1rem;
  row-gap: 5rem;
  grid-template-columns: repeat(3, 1fr);

  @media all and (max-width: ${layout.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const InterviewProcessIconographyEntry = styled.div`
  display: grid;
  row-gap: 1rem;

  & > div {
    justify-self: center;
  }
`

export const InterviewProcessImage = styled.div`
  display: grid;
  width: 158px;

  @media all and (max-width: ${layout.md}) {
    width: 85px;
  }
`

export const InterviewProcessButton = styled.div`
  display: grid;
  margin-top: 2rem;
`
